import { useState } from "react";
// import axios from "axios";
import { API_URL } from "../../../../../config";
import axiosInstance from "../../../../../axiosInstance";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function ContactUsPage() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosInstance.post(`${API_URL}/send-message`, formData);
            if (response.status === 201) {
                toast.success("Message sent successfully!");
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
                // console.log("Response:", response);
            } else {
                toast.error("Failed to send message. Please try again.");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("An unexpected error occurred. Please try again later.");
            }
        }
    }
    return (
        <>
            <div className="section-full twm-contact-one">
                <div className="section-content">
                    <div style={{ paddingTop: '110px' }} className="container">
                        {/* CONTACT FORM*/}
                        {/* <div className="contact-one-inner"> */}
                        <div className="row pb-5">
                            <div className="col-lg-12 col-md-12">
                                <div className="contact-form-outer">
                                    <div className="section-head left wt-small-separator-outer">
                                        <h2 className="wt-title">{t("Send Us a Message")}</h2>
                                        <p>{t("Feel free to contact us and we will get back to you as soon as we can.")}</p>
                                    </div>
                                    <form onSubmit={handleSubmit} className="cons-contact-form" method="post">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="nameInput">{t("Name")} :</label>
                                                    <input
                                                        id="nameInput"
                                                        name="name"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="emailInput">{t("Email")} :</label>
                                                    <input
                                                        id="emailInput"
                                                        name="email"
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="phoneInput">{t("Phone")} :</label>
                                                    <input
                                                        id="phoneInput"
                                                        name="phone"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Phone"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="subjectInput">{t("Subject")} :</label>
                                                    <input
                                                        id="subjectInput"
                                                        name="subject"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Subject"
                                                        value={formData.subject}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="messageInput">{t("Message")} :</label>
                                                    <textarea
                                                        id="messageInput"
                                                        name="message"
                                                        className="form-control"
                                                        rows={3}
                                                        placeholder="Message"
                                                        value={formData.message}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <button type="submit" className="site-button">{t("Send")}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </div>

        </>
    )
}

export default ContactUsPage;